import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { spaceS, spaceXL } from '@xingternal/tokens';

export const InfoIcons = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceXL};

  list-style: none;
  padding: 0;
  margin-bottom: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    flex-direction: column;
    gap: ${spaceS};
  }
`;
